module.exports = "<span id=\"loader-spinner\" class=\"loading\"></span>\n<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/khb.component.html
// module id = ./src/app/khb.component.html
// module chunks = main